<template>
<vx-card>
  <vs-popup :active.sync="showMissionsPopup" :title="'Prestations du contrat N°' + selectedContract">
    <!-- MISSIONS -->
    <div style="width: 1000px;">
      <MissionPopupTable :missions="missionsOfSociety"/>
    </div>
    <!-- /MISSIONS -->
  </vs-popup>
  <div class="vx-col">
    <div class="vx-row">
      <div class="vx-col sm:w-1/2 w-full mb-2">
        <h3>Ajout de noms de domaine</h3>
      </div>
      <!-- BOUTON DE RETOUR -->
      <div class="vx-col sm:w-1/2 w-full mb-2">
        <vs-button
          v-if="!showNetlinkPopup || editPurchaseMode || (showNetlinkPopup && atLeastOneNetlink)"
          class="float-right"
          radius
          color="primary"
          type="filled"
          icon-pack="feather"
          icon="icon-x"
          @click="returnPrevRoute"
        ></vs-button>
      </div>
      <!-- /BOUTON DE RETOUR -->
    </div>

    <div class="vx-row">
      <!-- CLIENT -->
      <!-- <div class="vx-col sm:w-1/8 mb-2">
        <vs-select
          v-model="selectedSociety"
          class="w-full select-medium mr-2"
          :disabled="purchaseDefinitiveLock"
          label="Client"
          autocomplete
        >
          <vs-select-item
            :key="index"
            :value="item.id"
            :text="item.name"
            v-for="(item, index) in societies"
            class="w-full"
          />
        </vs-select>
      </div> -->
      <!-- /CLIENT -->
      <!-- CONTRAT -->
      <!-- <div class="vx-col sm:w-1/8 mb-2">
        <vs-select
          autocomplete
          v-model="selectedContract"
          class="w-full select-medium mr-2"
          :disabled="purchaseLocked"
          label="Contrat"
        >
          <vs-select-item
            :key="index"
            :value="item.id"
            :text="item.id + ' - ' + getProductCategoryName(item.delivery)"
            v-for="(item, index) in contractOptions"
            class="w-full"
          />
        </vs-select>
      </div> -->
      <!-- /CONTRAT -->
      <!-- PRESTATAIRE -->
      <div class="vx-col sm:w-1/8 mb-2">
	  	<label for="" class="vs-select--label">Prestataire</label>
        <vs-select
          v-if="type == 'DNS'"
          v-model="selectedProvider"
          class="w-full select-medium mr-2"
          :disabled="purchaseDefinitiveLock"
          autocomplete
          :style="styleValidator('selectedProvider')"
          @change="validateOne(selectedProvider, 'selectedProvider')"
        >
          <vs-select-item
            :key="index"
            :value="item.id"
            :text="item.society"
            v-for="(item, index) in dnsProviders"
            class="w-full"
          />
        </vs-select>
        <vs-select
          v-else
          v-model="selectedProvider"
          class="w-full select-medium mr-2"
          :disabled="purchaseDefinitiveLock"
          autocomplete
          :style="styleValidator('selectedProvider')"
          @change="validateOne(selectedProvider, 'selectedProvider')"
        >
          <vs-select-item
            :key="index"
            :value="item.id"
            :text="item.society"
            v-for="(item, index) in providers"
            class="w-full"
          />
        </vs-select>
        <vx-tooltip v-if="validators['selectedProvider'] && validators['selectedProvider'].errText !== ''" :text="errText('selectedProvider')" class="ml-3">
          <vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
        </vx-tooltip>
      </div>
      <!-- /PRESTATAIRE -->
      <!-- SERVICE -->
      <div class="vx-col sm:w-1/4 mb-2">
	  	<label for="" class="vs-select--label">Service</label>
        <vs-select
          v-model="selectedService"
          class="w-full select-medium mr-2"
          :disabled="purchaseDefinitiveLock"
          autocomplete
          :style="styleValidator('selectedService')"
          @change="validateOne(selectedService, 'selectedService')"
        >
          <vs-select-item
            :key="index"
            :value="item"
            :text="getServiceName(item)"
            v-for="(item, index) in serviceOptions"
            class="w-full"
          />
        </vs-select>
        <vx-tooltip v-if="validators['selectedService'] && validators['selectedService'].errText !== ''" :text="errText('selectedService')" class="ml-3">
          <vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
        </vx-tooltip>
      </div>
      <!-- /SERVICE -->
    </div>

    <div class="vx-row">
      <!-- PRIX D'ACHAT -->
      <!-- <div v-if="type != 'DNS'" class="vx-col sm:w-1/4 w-full mb-2 mt-2">
        <vs-input
          class="w-full"
          :disabled="purchaseLocked"
          label-placeholder="Prix d'achat €"
          v-model.number="purchase.price"
        />
      </div> -->
      <!-- /PRIX D'ACHAT -->
      <!-- REFACTURABLE -->
      <!-- <div v-if="type != 'DNS'" class="vx-col sm:w-1/4 w-full mb-2">
        <vs-checkbox :disabled="purchaseLocked" v-model="purchase.isBillable">Facturable</vs-checkbox>
      </div> -->
      <!-- /REFACTURABLE -->
      <!-- MARGE PRIX -->
      <!-- <div v-if="type != 'DNS'" class="vx-col sm:w-1/4 w-full mb-2">
        <vs-input
          v-show="purchase.isBillable"
          class="w-full"
          :disabled="purchaseLocked"
          label-placeholder="Marge Prix"
          v-model.number="purchase.marginPrice"
        />      </div> -->
      <!-- MARGE /PRIX -->
      <!-- MARGE TAUX -->
      <!-- <div class="vx-col sm:w-1/4 w-full mb-2">
        <vs-input
          v-show="purchase.isBillable"
          class="w-full"
          :disabled="purchaseLocked"
          label-placeholder="Marge Taux"
          v-model.number="purchase.marginRate"
        />      </div> -->
      <!-- MARGE /TAUX -->
      <!-- FREQUENCY -->
      <!-- <div class="vx-col sm:w-1/4 w-full mb-2">
        <vs-select
          autocomplete
          v-model="purchase.recurrence"
          class="w-full select-medium mr-2"
          :disabled="purchaseLocked"
          label="Fréquence de la récurrence"
          placeholder=""
        >
          <vs-select-item
            :key="index"
            :value="item.value"
            :text="item.text"
            v-for="(item, index) in frequencyOptions"
            class="w-full"
          />
        </vs-select>
      </div> -->
      <!-- /FREQUENCY -->
      <!-- DATE -->
      <div class="vx-col sm:w-1/4 w-full mb-2">
      <vx-input-group
        class="w-full bottom"
      >
          <template slot="prepend">
            <div class="prepend-text bg-primary">
              <span class="flex"
                ><vs-icon icon="calendar_today" size="small"></vs-icon
              ></span>
            </div>
          </template>
          <flat-pickr
            class="w-full"
            v-model="purchase.boughtAt"
            :config="configEndDatePicker"
            placeholder="Date d'achat"
            :disabled="purchaseLocked"
            :style="styleValidator('boughtAt')"
            @input="validateOne(purchase.boughtAt, 'boughtAt')"
          />
        </vx-input-group>
        <vx-tooltip v-if="validators['boughtAt'] && validators['boughtAt'].errText !== ''" :text="errText('boughtAt')" class="ml-3">
          <vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
        </vx-tooltip>
      </div>
      <!-- /DATE -->
    </div>

    <div class="vx-row">
      <!-- COMMENTAIRE -->
      <div class="vx-col sm:w-1/4 w-full mb-2">
        <vs-input
          v-model="purchase.commentary"
          label="Commentaire"
          class="mb-0 md:mt-10 mt-6"
          :disabled="purchaseLocked"
        />
      </div>
      <!-- /COMMENTAIRE -->
    </div>
    <div class="vx-row justify-end">
      <div v-if="is_dns == false" class="vx-col">
        <vs-button
          v-if="purchaseLocked"
          class="float-right"
          color="primary"
          type="filled"
          @click="enterEditMode"
        >Modifier Achat
        </vs-button>
      </div>
      <div class="vx-col align-center">
        <vs-button
          v-if="selectedContract"
          color="primary"
          type="filled"
          @click="displayMissionsPopup"
        >Voir les prestations du contrat
        </vs-button>
      </div>
    </div>
    <div class="vx-row">
      <!-- NETLINK POPUP -->
      <div class="vx-col w-full mb-2">
        <span v-show="showNetlinkPopup || (atLeastOneNetlink && editPurchaseMode)"><NetlinkPopupTable :purchaseId="purchaseId" :societyId="selectedSociety" @netlink-update="checkNetlinkNumber($event)"/></span>
        <span v-show="showDnsPopup || atLeastOneDns"><DnsPopupTable ref="dnsPopup" :purchaseId="purchaseId" :providerId="selectedProvider" :price="purchase.price"/></span>
      </div>
      <!-- /NETLINK POPUP -->
    </div>
    <!-- DESCRIPTION DU CONTRAT -->
    <div class="vx-row">
    </div>
    <!-- /DESCRIPTION DU CONTRAT -->

    <div class="vx-row float-right mt-3">
      <div class="vx-col w-full">
        <!-- REINITIALISER -->
        <!-- <vs-button
          color="warning"
          type="border"
          class="mb-2 mr-3"
          @click="
            purchase.firstname = purchase.lastname = purchase.email = purchase.phone = purchase.image_url = purchase.commentary = purchase.role =
              ''
          "
          >Réinitialiser</vs-button
        > -->
        <!-- /REINITIALISER -->
        <!-- SUBMIT -->
        <vs-button v-if="is_netlink && !showNetlinkPopup && !editPurchaseMode" class="mb-2" @click="formSubmittedAndShowNetlink">Enregistrer et Ajouter Netlink</vs-button>
        <vs-button v-else-if="is_netlink && !showNetlinkPopup && editPurchaseMode" class="mb-2" @click="editFormSubmittedAndShowNetlink">Enregistrer et Ajouter Netlink</vs-button>
        <vs-button v-else-if="is_dns && !showNetlinkPopup && !showDnsPopup && !editPurchaseMode" class="mb-2" @click="formSubmittedAndShowDns">Enregistrer et Ajouter NDD</vs-button>
        <vs-button v-else-if="is_dns && !showNetlinkPopup && !showDnsPopup && editPurchaseMode" class="mb-2" @click="editFormSubmittedAndShowDns">Enregistrer et Ajouter NDD</vs-button>
        <vs-button v-else-if="!showDnsPopup && !showNetlinkPopup && !editPurchaseMode" class="mb-2" @click="formSubmitted">Enregistrer Achat</vs-button>
        <vs-button v-else-if="!showDnsPopup && !showNetlinkPopup && editPurchaseMode" class="mb-2" @click="editFormSubmitted">Enregistrer Achat</vs-button>
        <vs-button v-else-if="showNetlinkPopup && atLeastOneNetlink" class="mb-2" @click="netlinkSubmitted">Enregistrer</vs-button>
        <vs-button v-else-if="showDnsPopup" class="mb-2" @click="dnsSubmitted">Enregistrer</vs-button>

        <!-- /SUBMIT -->
      </div>
    </div>
  </div>
  </vx-card>
</template>

<script>
import MissionPopupTable from "@/components/tables/MissionPopupTable";
import NetlinkPopupTable from "@/components/tables/NetlinkPopupTable";
import DnsPopupTable from "@/components/tables/DnsPopupTable";
import Purchase from "@/entities/Purchase";
import Contract from "@/entities/Contract";
import Validator from "@/entities/Validator";
import Mission from "@/entities/Mission";
import store from "@/store/store";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import VxTooltip from "./../../../components/widgets/vx-tooltip/VxTooltip.vue";

export default {
	name: "DnsForm",
	mixins: [dbFieldConvertor],
	props: {
		chartParams: Object,
		isPercent: Boolean,
		type: String,
	},
	components: {
		flatPickr,
		MissionPopupTable,
		NetlinkPopupTable,
		DnsPopupTable,
		VxTooltip
	},
	data() {
		return {
			// USER OBJECT
			purchase: Purchase.getFormFields(),
			apiUrl: this.$store.state.backendApiUrl,
			// FORM SELECT OPTIONS
			statusOptions: [
				{text: "Actif", value: 1},
				{text: "Inactif", value: 0}
			],
			frequencyOptions: [
				{text: "One shot", value: 0},
				{text: "Mensuel", value: 1},
				{text: "Bimestriel", value: 2},
				{text: "Trimestriel", value: 3},
				{text: "Quadrimestriel", value: 4},
				{text: "Semestriel", value: 5},
				{text: "Annuel", value: 6}
			],
			/**
			 * Refer to backend server to understand more about type and its possible value
			 */
			typeOptions: [
				{text: "Commercial", value: 2},
				{text: "Consultant", value: 3}
			],
			contractOptions: [],
			providerOptions: [],
			serviceOptions: [],
			missionsOfSociety: [],
			selectedSociety: null,
			selectedContract: null,
			selectedProvider: null,
			selectedService: null,
			purchaseLocked: false,
			purchaseDefinitiveLock: false,
			editPurchaseMode: false,
			is_netlink: false,
			netlinkServiceName: "Netlinking",
			is_dns: false,
			dnsServiceName: "Domaine",
			showNetlinkPopup: false,
			showDnsPopup: false,
			atLeastOneNetlink: false,
			atLeastOneDns: false,
			purchaseId: null,
			configEndDatePicker: {
				// minDate: new Date(),
				dateFormat: "j/n/Y"
			},
			showMissionsPopup: false,

			dnsProviders: [],
			dnsServices: [],
			validators: {},
			check: true,
		};
	},
	created() {
		// //console.log("Test: ", this.convertFrenchNumberToInternational("43,3"))
		let today = new Date(Date.now());
		this.purchase.boughtAt = today.toISOString();
		// this.configEndDatePicker.minDate = new Date(this.configEndDatePicker.minDate.getFullYear(), this.configEndDatePicker.minDate.getMonth(), 1)
		this.getAllSocieties();
		this.getAllProviders();
		this.getAllServices();
	},
	computed: {
		societies: () => {
			return store.state.societies;
		},
		providers: () => {
			return store.state.providers;
		},
		services: () => {
			return store.state.services;
		},
	},
	watch: {
		selectedSociety: function(){
			//console.log("selectedSociety watch");
			this.purchase.contract_society_id = this.selectedSociety;
			this.getAllContractsForSociety(this.selectedSociety);
		},
		selectedContract: function(){
			//console.log("selectedContract watch");
			this.purchase.contract_id = this.selectedContract;
			this.getAllMissionsForContract(this.selectedContract);
		},
		selectedProvider: function(){
			//console.log("selectedProvider watch");
			this.purchase.users_id = this.selectedProvider;
			this.serviceOptions = this.setServiceOptions(this.selectedProvider);
			this.selectedService = this.serviceOptions[0];
		},
		selectedService: function(){
			//console.log("selectedService watch");
			this.purchase.service_id = this.selectedService;
			this.is_netlink = this.checkServiceIsNetlink(this.selectedService);
			this.is_dns = this.checkServiceIsDns(this.selectedService);
		},
		is_netlink: function(){
			if(this.is_netlink){
				//console.log("is_netlink", this.is_netlink);
			}
		},
		is_dns: function(){
			if(this.is_dns){
				//console.log("is_dns", this.is_dns);
			}
		},
		services: function(data){
			if(this.type == "DNS"){
				//console.log("store.state.services", data);
				let dns_providers = [];
				let dns_service = data.filter(service => service.name == this.dnsServiceName);
				if(dns_service.length > 0){
					this.dnsServices = dns_service;
					let dns_service_id = dns_service[0].id;
					//console.log("dns_service_id", dns_service_id);

					if(dns_service_id){
						dns_providers = this.providers.filter(provider => {
							let service_id_list = provider.service_id_list ? provider.service_id_list.split(",") : [];
							//console.log(service_id_list);
							if(service_id_list.length > 0){
								let service_id_found_index = service_id_list.findIndex(service_id => service_id == dns_service_id);
								if(service_id_found_index >= 0) return provider;
							}
						});
						//console.log("dns_providers", dns_providers);
					}
				}
				if(dns_providers.length > 0){
					this.dnsProviders = dns_providers;
				}
				else{
					this.dnsProviders = this.providers;
				}
			}
		}
	},
	methods: {
		validateOne(val, name){
			let value = val;
			value == 0 ? value = "0" : "";
			let constname = "";
			if(name == "boughtAt"){
				constname = "dateConstraint";
				this.validators[name] = new Validator({constraintName: constname});
				if(this.purchase.boughtAt == 0 || this.purchase.boughtAt == null){
					this.validators[name].valid = false;
					this.validators[name].errText = "Ce champ ne peut être vide.";
					this.check = false;
				}
				else{
					this.validators["boughtAt"].errText = "";
					this.validators[name].valid = true;
				}
			}
			else{
				constname = "isNumberConstrait";
				this.validators[name] = new Validator({constraintName: constname});
				this.validators[name].check(value);
				this.validators[name].valid == false && this.validators[name].errText == "" ? this.validators[name].errText = "Ce champ ne peut être vide." : "";
				this.validators[name].valid == false && this.validators[name].errText !== "" ? this.check = false : "";
			}
			this.$forceUpdate();
		},
		errText(name){
			if(this.validators[name] && this.validators[name].errText !== ""){
				return this.validators[name].errText;
			}
		},
		styleValidator(name){
			if(this.validators[name] && this.validators[name].valid == false && this.validators[name].errText !== ""){
				switch(name){
				case"boughtAt":
					return "border: 1px solid red !important; width: auto !important; border-radius: 0 5px 5px 0;";
				default:
					return "border: 1px solid red !important; width: auto !important; border-radius: 5px;";
				}
			}
			else if(this.validators[name] && this.validators[name].errText == ""){
				switch(name){
				case"boughtAt":
					return "border: 1px solid green !important; width: auto !important; border-radius: 0 5px 5px 0;";
				default:
					return "border: 1px solid green !important; width: auto !important; border-radius: 5px;";
				}
			}
			else{
				return "border: none !important; border-radius: none;";
			}
		},
		/**
		 * Send the data to tha API to create the new purchase
		 */
		formSubmitted() {
			this.check = true;
			let fields = ["selectedProvider", "selectedService"];
			let fieldsVal = [this.selectedProvider, this.selectedService];
			for(let i = 0; i < fields.length; i++){
				let name = fields[i];
				let value = fieldsVal[i];
				value == 0 ? value = "0" : "";
				this.validators[name] = new Validator({constraintName: "isNumberConstrait"});
				this.validators[name].check(value);
				this.validators[name].valid == false && this.validators[name].errText == "" ? this.validators[name].errText = "Ce champ ne peut être vide." : "";
				this.validators[name].valid == false && this.validators[name].errText !== "" ? this.check = false : "";
			}

			this.validators["boughtAt"] = new Validator({constraintName: "dateConstraint"});
			if(this.purchase.boughtAt == 0 || this.purchase.boughtAt == null){
				this.validators["boughtAt"].valid = false;
				this.validators["boughtAt"].errText = "Ce champ ne peut être vide.";
				this.check = false;
			}
			else{
				this.validators["boughtAt"].errText = "";
				this.validators["boughtAt"].valid = true;
			}

			this.$forceUpdate();
			if(this.check == true){
				let formatedDate = this.purchase.boughtAt.substring(0, 10);
				formatedDate = formatedDate.split("/").reverse().join("-");
				formatedDate = formatedDate + " 02:00:00";
				this.$http.post(this.apiUrl + "purchase/add", {
					price: this.convertFrenchNumberToInternational(this.purchase.price),
					recurrence: this.purchase.recurrence,
					margin_price: this.convertFrenchNumberToInternational(this.purchase.marginPrice),
					margin_rate: this.purchase.marginRate,
					is_billable: this.purchase.isBillable,
					commentary: this.purchase.commentary,
					bought_at: formatedDate,
					contract_id: this.purchase.contract_id,
					contract_society_id: this.purchase.contract_society_id,
					users_id: this.purchase.users_id,
					service_id: this.purchase.service_id,
					is_delivered: 0,
					recurrence_active: this.purchase.recurrence
				}).then(res => {
					//console.log(res);
					this.$store.dispatch("getAllPurchasesWithRecurring");
					// Send a success notification to the user
					this.$vs.notify({title: "Succès", text: "Achat ajouté avec succès."});
					this.$router.go(-1);
				}).catch(err => {
					//console.log(err);
					this.$vs.notify({title: "Echec", text: "L'achat n'a pas été ajouté."});
				});
			}
			else{
				this.$vs.notify({
					title: "Echec",
					text: "Veuillez remplir tous les champs correctement."
				});
				return false;
			}
		},

		/**
		 * Send the data to tha API to create the new purchase and show Netlink
		 */
		formSubmittedAndShowNetlink() {
			this.purchaseLocked = true;
			this.purchaseDefinitiveLock = true;
			let formatedDate = this.purchase.boughtAt.substring(0, 10);
			formatedDate = formatedDate.split("/").reverse().join("-");
			formatedDate = formatedDate + " 02:00:00";
			this.$http.post(this.apiUrl + "purchase/add", {
				price: this.convertFrenchNumberToInternational(this.purchase.price),
				recurrence: this.purchase.recurrence,
				margin_price: this.convertFrenchNumberToInternational(this.purchase.marginPrice),
				margin_rate: this.purchase.marginRate,
				is_billable: this.purchase.isBillable,
				commentary: this.purchase.commentary,
				bought_at: formatedDate,
				contract_id: this.purchase.contract_id,
				contract_society_id: this.purchase.contract_society_id,
				users_id: this.purchase.users_id,
				service_id: this.purchase.service_id,
				is_delivered: 0,
				recurrence_active: this.purchase.recurrence
			}).then(res => {
				//console.log(res);
				this.purchaseId = res.data.insertId;
				//console.log(this.purchaseId);
				this.showNetlinkPopup = true;
				this.$store.dispatch("getAllPurchasesWithRecurring");
				// Send a success notification to the user
				this.$vs.notify({title: "Succès", text: "Achat ajouté avec succès."});
			}).catch(err => {
				//console.log(err);
				this.$vs.notify({title: "Echec", text: "L'achat n'a pas été ajouté."});
			});
		},

		formSubmittedAndShowDns() {
			this.check = true;
			let fields = ["selectedProvider", "selectedService"];
			let fieldsVal = [this.selectedProvider, this.selectedService];
			for(let i = 0; i < fields.length; i++){
				let name = fields[i];
				let value = fieldsVal[i];
				value == 0 ? value = "0" : "";
				this.validators[name] = new Validator({constraintName: "isNumberConstrait"});
				this.validators[name].check(value);
				this.validators[name].valid == false && this.validators[name].errText == "" ? this.validators[name].errText = "Ce champ ne peut être vide." : "";
				this.validators[name].valid == false && this.validators[name].errText !== "" ? this.check = false : "";
			}

			this.validators["boughtAt"] = new Validator({constraintName: "dateConstraint"});
			if(this.purchase.boughtAt == 0 || this.purchase.boughtAt == null){
				this.validators["boughtAt"].valid = false;
				this.validators["boughtAt"].errText = "Ce champ ne peut être vide.";
				this.check = false;
			}
			else{
				this.validators["boughtAt"].errText = "";
				this.validators["boughtAt"].valid = true;
			}

			this.$forceUpdate();

			if(this.check == true){
				this.showDnsPopup = true;
			}
			else{
				this.$vs.notify({
					title: "Echec",
					text: "Veuillez remplir tous les champs correctement."
				});
				return false;
			}
			/*
			 * this.purchaseLocked = true
			 * this.purchaseDefinitiveLock = true
			 * let formatedDate = this.purchase.boughtAt.substring(0,10)
			 * formatedDate = formatedDate.split('/').reverse().join('-')
			 * formatedDate = formatedDate + " 02:00:00"
			 * this.$http.post(this.apiUrl + "purchase/add", {
			 *   price: this.convertFrenchNumberToInternational(this.purchase.price),
			 *   recurrence: this.purchase.recurrence,
			 *   margin_price: this.convertFrenchNumberToInternational(this.purchase.marginPrice),
			 *   margin_rate: this.purchase.marginRate,
			 *   is_billable: this.purchase.isBillable,
			 *   commentary: this.purchase.commentary,
			 *   bought_at: formatedDate,
			 *   contract_id: this.purchase.contract_id,
			 *   contract_society_id: this.purchase.contract_society_id,
			 *   users_id: this.purchase.users_id,
			 *   service_id: this.purchase.service_id,
			 *   is_delivered: 0,
			 *   recurrence_active: this.purchase.recurrence
			 * }).then(res => {
			 *   //console.log(res)
			 *   this.purchaseId = res.data.insertId
			 *   //console.log(this.purchaseId)
			 *   this.showDnsPopup = true
			 *   this.$store.dispatch("getAllPurchasesWithRecurring");
			 *   // Send a success notification to the user
			 *   this.$vs.notify({title:'Succès',text:"Achat ajouté avec succès."})
			 * }).catch(err => {
			 *   //console.log(err)
			 *   this.$vs.notify({title:'Echec',text:"L'achat n'a pas été ajouté."})
			 * })
			 */
		},

		enterEditMode(){
			if(!this.atLeastOneNetlink && !this.atLeastOneDns){
				this.purchaseDefinitiveLock = false;
			}
			this.showNetlinkPopup = false;
			this.showDnsPopup = false;
			this.editPurchaseMode = true;
			this.purchaseLocked = false;
		},

		editFormSubmittedAndShowNetlink() {
			this.purchaseLocked = true;
			this.purchaseDefinitiveLock = true;
			let formatedDate = this.purchase.boughtAt.substring(0, 10);
			formatedDate = formatedDate.split("/").reverse().join("-");
			formatedDate = formatedDate + " 02:00:00";
			this.$http.post(this.apiUrl + "purchase/edit", {
				id: this.purchaseId,
				price: this.convertFrenchNumberToInternational(this.purchase.price),
				recurrence: this.purchase.recurrence,
				margin_price: this.convertFrenchNumberToInternational(this.purchase.marginPrice),
				margin_rate: this.purchase.marginRate,
				is_billable: this.purchase.isBillable,
				commentary: this.purchase.commentary,
				bought_at: formatedDate,
				contract_id: this.purchase.contract_id,
				contract_society_id: this.purchase.contract_society_id,
				users_id: this.purchase.users_id,
				service_id: this.purchase.service_id,
				is_delivered: 0,
				recurrence_active: this.purchase.recurrence
			}).then(res => {
				//console.log(res);
				this.showNetlinkPopup = true;
				this.$store.dispatch("getAllPurchasesWithRecurring");
				// Send a success notification to the user
				this.$vs.notify({title: "Succès", text: "Achat modifié avec succès."});
			}).catch(err => {
				//console.log(err);
				this.$vs.notify({title: "Echec", text: "L'achat n'a pas été modifié."});
			});
		},

		editFormSubmittedAndShowDns() {
			this.check = true;
			let fields = ["selectedProvider", "selectedService"];
			let fieldsVal = [this.selectedProvider, this.selectedService];
			for(let i = 0; i < fields.length; i++){
				let name = fields[i];
				let value = fieldsVal[i];
				value == 0 ? value = "0" : "";
				this.validators[name] = new Validator({constraintName: "isNumberConstrait"});
				this.validators[name].check(value);
				this.validators[name].valid == false && this.validators[name].errText == "" ? this.validators[name].errText = "Ce champ ne peut être vide." : "";
				this.validators[name].valid == false && this.validators[name].errText !== "" ? this.check = false : "";
			}

			this.validators["boughtAt"] = new Validator({constraintName: "dateConstraint"});
			if(this.purchase.boughtAt == 0 || this.purchase.boughtAt == null){
				this.validators["boughtAt"].valid = false;
				this.validators["boughtAt"].errText = "Ce champ ne peut être vide.";
				this.check = false;
			}
			else{
				this.validators["boughtAt"].errText = "";
				this.validators["boughtAt"].valid = true;
			}

			this.$forceUpdate();

			if(this.check == true){
				/*
				 * this.purchaseLocked = true
				 * this.purchaseDefinitiveLock = true
				 */
				let formatedDate = this.purchase.boughtAt.substring(0, 10);
				formatedDate = formatedDate.split("/").reverse().join("-");
				formatedDate = formatedDate + " 02:00:00";
				this.$http.post(this.apiUrl + "purchase/edit", {
					id: this.purchaseId,
					price: this.convertFrenchNumberToInternational(this.purchase.price),
					recurrence: this.purchase.recurrence,
					margin_price: this.convertFrenchNumberToInternational(this.purchase.marginPrice),
					margin_rate: this.purchase.marginRate,
					is_billable: this.purchase.isBillable,
					commentary: this.purchase.commentary,
					bought_at: formatedDate,
					contract_id: this.purchase.contract_id,
					contract_society_id: this.purchase.contract_society_id,
					users_id: this.purchase.users_id,
					service_id: this.purchase.service_id,
					is_delivered: 0,
					recurrence_active: this.purchase.recurrence
				}).then(res => {
					//console.log(res);
					this.showDnsPopup = true;
					this.$store.dispatch("getAllPurchasesWithRecurring");
					// Send a success notification to the user
					this.$vs.notify({title: "Succès", text: "Achat modifié avec succès."});
				}).catch(err => {
					//console.log(err);
					this.$vs.notify({title: "Echec", text: "L'achat n'a pas été modifié."});
				});
			}
			else{
				this.$vs.notify({
					title: "Echec",
					text: "Veuillez remplir tous les champs correctement."
				});
				return false;
			}
		},

		editFormSubmitted() {
			this.check = true;
			let fields = ["selectedProvider", "selectedService"];
			let fieldsVal = [this.selectedProvider, this.selectedService];
			for(let i = 0; i < fields.length; i++){
				let name = fields[i];
				let value = fieldsVal[i];
				value == 0 ? value = "0" : "";
				this.validators[name] = new Validator({constraintName: "isNumberConstrait"});
				this.validators[name].check(value);
				this.validators[name].valid == false && this.validators[name].errText == "" ? this.validators[name].errText = "Ce champ ne peut être vide." : "";
				this.validators[name].valid == false && this.validators[name].errText !== "" ? this.check = false : "";
			}

			this.validators["boughtAt"] = new Validator({constraintName: "dateConstraint"});
			if(this.purchase.boughtAt == 0 || this.purchase.boughtAt == null){
				this.validators["boughtAt"].valid = false;
				this.validators["boughtAt"].errText = "Ce champ ne peut être vide.";
				this.check = false;
			}
			else{
				this.validators["boughtAt"].errText = "";
				this.validators["boughtAt"].valid = true;
			}

			this.$forceUpdate();

			if(this.check == true){
				this.purchaseLocked = true;
				let formatedDate = this.purchase.boughtAt.substring(0, 10);
				formatedDate = formatedDate.split("/").reverse().join("-");
				formatedDate = formatedDate + " 02:00:00";
				this.$http.post(this.apiUrl + "purchase/edit", {
					id: this.purchaseId,
					price: this.convertFrenchNumberToInternational(this.purchase.price),
					recurrence: this.purchase.recurrence,
					margin_price: this.convertFrenchNumberToInternational(this.purchase.marginPrice),
					margin_rate: this.purchase.marginRate,
					is_billable: this.purchase.isBillable,
					commentary: this.purchase.commentary,
					bought_at: formatedDate,
					contract_id: this.purchase.contract_id,
					contract_society_id: this.purchase.contract_society_id,
					users_id: this.purchase.users_id,
					service_id: this.purchase.service_id,
					is_delivered: 0,
					recurrence_active: this.purchase.recurrence
				}).then(res => {
					//console.log(res);
					this.$store.dispatch("getAllPurchasesWithRecurring");
					// Send a success notification to the user
					this.$vs.notify({title: "Succès", text: "Achat modifié avec succès."});
					this.$router.go(-1);
				}).catch(err => {
					//console.log(err);
					this.$vs.notify({title: "Echec", text: "L'achat n'a pas été modifié."});
				});
			}
			else{
				this.$vs.notify({
					title: "Echec",
					text: "Veuillez remplir tous les champs correctement."
				});
				return false;
			}
		},

		/**
		 * Send the data to tha API to create the new netlinks
		 */
		netlinkSubmitted() {
			this.$router.go(-1);
		},

		submitPurchase(){
			return new Promise((resolve, reject) => {
				let formatedDate = this.purchase.boughtAt.substring(0, 10);
				formatedDate = formatedDate.split("/").reverse().join("-");
				formatedDate = formatedDate + " 02:00:00";
				this.$http.post(this.apiUrl + "purchase/add", {
					price: this.convertFrenchNumberToInternational(this.purchase.price),
					recurrence: this.purchase.recurrence,
					margin_price: this.convertFrenchNumberToInternational(this.purchase.marginPrice),
					margin_rate: this.purchase.marginRate,
					is_billable: this.purchase.isBillable,
					commentary: this.purchase.commentary,
					bought_at: formatedDate,
					contract_id: 1,
					contract_society_id: 206,
					users_id: this.purchase.users_id,
					service_id: this.purchase.service_id,
					is_delivered: 0,
					recurrence_active: this.purchase.recurrence
				}).then(res => {
					//console.log(res);
					this.purchaseId = res.data.insertId;
					//console.log(this.purchaseId);
					this.$store.dispatch("getAllPurchasesWithRecurring");
					// Send a success notification to the user
					this.$vs.notify({title: "Succès", text: "Achat ajouté avec succès."});
					resolve(res.data.insertId);
				}).catch(err => {
					//console.log(err);
					this.$vs.notify({title: "Echec", text: "L'achat n'a pas été ajouté."});
					reject(err);
				});
			});
		},

		dnsSubmitted() {
			// GET PURCHASE PRICE
			this.$refs.dnsPopup.getPurchasePrice()
				.then(purchasePrice => {
					this.purchase.price = purchasePrice;
					// SUBMIT PURCHASE
					this.submitPurchase()
						.then(purchaseId => {
							let formatedDate = this.purchase.boughtAt.substring(0, 10);
							formatedDate = formatedDate.split("/").reverse().join("-");
							formatedDate = formatedDate + " 02:00:00";
							// SUBMIT DNSs
							this.$refs.dnsPopup.submitAllDns(purchaseId, formatedDate, this.purchase.users_id)
								.then(dns_reponses => {
									this.$vs.notify({title: "Succès", text: "Noms de domaines ajoutés avec succès."});
									this.returnPrevRoute();
								})
								.catch(dns_err => {
									this.$vs.notify({title: "Echec", text: "Une erreur est survenue lors de l'ajout des noms de domaines."});
								});
						});
				});
			//console.log("dnsSubmitted");
			/*
			 * this.$refs.dnsPopup.newDns()
			 *   .then(res => {
			 *     this.$router.go(-1);
			 *   })
			 *   .catch(err => {
			 *     //console.log(err)
			 *   })
			 */
		},

		displayMissionsPopup(){
			this.showMissionsPopup = true;
		},

		/**
		 * Redirect to the previous page
		 */
		returnPrevRoute() {
			this.$router.go(-1);
		},


		getAllServices(){
			this.$store.dispatch("getAllServices");
		},
		/**
		 * Get all societies in store states
		 */
		getAllSocieties(){
			this.$store.dispatch("getAllSocieties");
		},
		getAllProviders(){
			this.$store.dispatch("getAllProviders");
		},
		getAllContractsForSociety(societyId){
			Contract.getContractsforSociety(societyId, (err, res) => {
				if(err) //console.log(err);
				if(res) {
					this.contractOptions = res;
					//console.log("this.contractOptions.length", this.contractOptions.length);
					if(this.contractOptions.length > 0){
						this.selectedContract = this.contractOptions[0].id;
					}
					else{
						this.selectedContract = null;
					}
				}
			});
			//console.log("getAllContractsForSociety");
		},
		getAllMissionsForContract(contractId){
			//console.log(contractId);
			Mission.getMissionsForContract(contractId, (err, res) => {
				if(err) //console.log(err);
				if(res) {
					//console.log(res);
					this.missionsOfSociety = res;
				}
			});
			//console.log("getAllMissionsForContract");
		},
		setServiceOptions(provider_id){
			let foundProvider = this.providers.find(provider => provider_id == provider.id);
			let provider_service_id_list = foundProvider.service_id_list ? foundProvider.service_id_list.split(",") : [];
			if(provider_service_id_list.length > 0){
				return this.type == "DNS" ? provider_service_id_list.filter(id => id == this.dnsServices[0].id) : provider_service_id_list;
			}
			else{
				return [];
			}
			// return this.type == "DNS" ? foundProvider.service_id_list.split(",") : foundProvider.service_id_list.split(",")
		},

		getServiceName(service_id){
			let service = this.services.find(service_element => service_element.id == service_id);
			return service.name;
		},

		checkServiceIsNetlink(service_id){
			let service = this.services.find(service => service.id == service_id);
			if(service != undefined){
				if(service.name == this.netlinkServiceName){
					return true;
				}
			}
			return false;
		},

		checkServiceIsDns(service_id){
			let service = this.services.find(service => service.id == service_id);
			if(service != undefined){
				if(service.name == this.dnsServiceName){
					return true;
				}
			}
			return false;
		},

		checkNetlinkNumber(netlinkNumber){
			if(netlinkNumber >= 1){
				this.atLeastOneNetlink = true;
			}
			else{
				this.atLeastOneNetlink = false;
				if(!this.purchaseLocked){
					this.purchaseDefinitiveLock = false;
				}
			}
		},

		checkDnsNumber(dnsNumber){
			if(dnsNumber >= 1){
				this.atLeastOneDns = true;
			}
			else{
				this.atLeastOneDns = false;
				if(!this.purchaseLocked){
					this.purchaseDefinitiveLock = false;
				}
			}
		},
	}
};
</script>

<style scoped>
.role_selector_container {
  justify-content: space-between;
  width: 40%;
}

.role_container {
  justify-content: center;
}

.space_div {
  margin: 5px;
}

</style>
